<script>
	import request from './request.vue';

	const categorySchema = [
		{
			name: "id",
			displayName: "Código",
			kind: "text",
			validation: "",
			placeholder: "Digite o código da categoria",
			defaultSort: true,
			readOnly: true,
			search: {
				show: false,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "name",
			displayName: "Nome",
			kind: "text",
			validation: "required",
			placeholder: "Digite o nome da categoria",
			defaultSort: true,
			notInFilters: false,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "description",
			displayName: "Descrição",
			kind: "long-text",
			validation: "",
			placeholder: "Escreva a descrição",
			defaultSort: true,
			notInFilters: true,
			search: {
				show: true,
				endWildcard: true,
				startWildcard: true,
			},
		},
		{
			name: "iconUrl",
			displayName: "Ícone",
			kind: "picture-url",
			validation: "",
			placeholder: "",
			search: {
				show: false,
			},
			upload: async function (id, file) {
				const formData = new FormData();
				formData.append("file", file, file.name);
				let response = await request.sendFormData("category", `uploadIcon/${id}`, formData);
				return response.data;
			},
		},
	];

	export default {
		create: async function (entity) {
			const response = await request.send("category", "create", entity, true);
			return response.data;
		},
		getInfo: async function (id) {
			const response = await request.send("category", "read", { id }, true);
			return response.data;
		},
		updateInfo: async function (product) {
			let response = await request.send("category", "update", product, true);
			return response.data;
		},
		remove: async function (id) {
			return request.send("category", "delete", { id }, true);
		},
		search: async function(parameters) {
			return request.send("category", "search", parameters, true);
		},
		getAll: async function() {
			const response = await request.send("category", "getAll", {}, true);
			return response.data;
		},
		getSchema: function() {
			return categorySchema;
		},
	}
</script>
